<template>
  <div class="full-area" :class="`question-${data.sys.contentType.sys.id}`">
    <header class="question-header align-bottom" v-if="!(data.fields.questionImage && data.fields.questionImage.fields.file.url)">
      <h2>{{data.fields.title}}</h2>
    </header>

    <header class="question-header image-question contain-image"
      v-if="data.fields.questionImage && data.fields.questionImage.fields.file.url"
    >
      <div
        class="img"
        :style="{'backgroundImage': `url(${data.fields.questionImage.fields.file.url})`}"
      ></div>
    </header>
    <content class="content delay-entry" :class="{'is-vertical': this.data.fields.isVertical}">
      <div class="slider-bubbles">
        <div
          class="slider-bubble"
          :class="{'selected': index === form.selected[0]}"
          :style="{
            'width': `${(Math.abs(index-((data.fields.steps + 1) / 2)) + 2) * 10 / data.fields.steps}vh`,
            'height': `${(Math.abs(index-((data.fields.steps + 1) / 2)) + 2) * 10 / data.fields.steps}vh`,
            'border-color': chromaList[index],
            'background-color': index === form.selected[0] ? chromaList[index] : '#fff'
          }"
          v-for="index in data.fields.steps"
          :key="index"
          @click="selectThis(index)"
        ></div>
      </div>
      <div class="slider-labels">
        <div
          class="label-item"
          v-for="text in data.fields.textScale"
          :key="text"
        >
          {{text}}
        </div>
      </div>
    </content>
    <footer>
      <SkipQuestionButton
        :location="'locate-bottom'"
        v-on:skip="selectThis('NS/NR')"
      ></SkipQuestionButton>
    </footer>
  </div>
</template>

<script>
import chroma from 'chroma-js'

export default {
  name: 'Slider',

  props: [ 'data' ],

  components: {
    SkipQuestionButton: () => import('Components/base/SkipQuestionButton')
  },

  data () {
    return {
      form: {
        question: this.data.fields.title,
        id: this.data.sys.id,
        from: 1,
        to: this.data.fields.steps || this.data.fields.textScale.length,
        selected: [],
        timeToCompletion: null,
        timestamps: {
          start: new Date(),
          finish: null,
          valid: null
        }
      },
      timer: null
    }
  },

  methods: {
    selectThis (item) {
      this.form.selected = [item]
      this.form.timestamps.valid = new Date()
      this.form.timeToCompletion = this.form.timestamps.valid.getTime() - this.form.timestamps.start.getTime()
      setTimeout(() => {
        this.next()
      }, 200)
    },
    next () {
      this.form.timestamps.finish = new Date()
      this.calculateScores()
      this.$emit('next', this.form)
    },
    validInput (value) {
      // Add simple validation: if it exists, it is valid.
      if (value >= this.form.from && value <= this.form.to) {
        return true
      } else {
        return false
      }
    },
    calculateScores () {
      if (!this.data.fields.formula) {
        return
      }
      var options = []
      for (var i = 1; i <= this.data.fields.steps; i++) {
        options.push(i)
      }
      this.$store.dispatch('CALCULATE_WEIGHTED_QUESTION', {
        formula: this.data.fields.formula,
        selected: this.form.selected,
        options: options,
        maxAnswers: 1
      }).then(scores => {
        this.form.weighted = scores.weighted.slice(0)
        this.form.weightedMin = scores.weightedMin
        this.form.weightedMax = scores.weightedMax
      }).catch(err => {
        console.log('err: ', err)
      })
    }
  },

  computed: {
    chromaList () {
      return chroma.scale(['#f56c6c', '#88d8b0']).mode('lch').colors(this.data.fields.steps + 1)
    }
  },

  watch: {
    // Add a simple watch to trigger next automatically after some ms
    'form.selected': function (newVal, oldVal) {
      if (this.validInput(newVal) && Number.isInteger(newVal)) {
        setTimeout(() => {
          this.next()
        }, 200)
      }
    }
  }
}
</script>

<style lang="scss">
</style>

<style scoped lang="scss">
  .content {
    flex-direction: column;
  }

  .slider-bubbles,
  .slider-labels {
    width: 80%;
    margin: 0 auto;
    margin-bottom: 20px;
    display: flex;
    flex-orientation: row;
    justify-content: space-between;
    align-items: center;

    @include breakpoint($tablet) {
      width: 45vh;
    }

    .slider-bubble {
      width: 40px;
      height: 40px;
      background: white;
      border: 2px solid gray;
      border-radius: 100%;

      @include breakpoint($tablet) {
        width: 150px;
        height: 50px;
      }
      &.selected {
        animation: standOut 0.4s ease-in-out forwards;
      }
    }
  }

  .slider-labels {
    font-weight: bold;
    color: $color-emphasis-alt;
    div:first-child {
      color: $color-emphasis;
    }
  }
</style>
